import React, { useRef, useState } from 'react';
import { Snackbar } from '@xo-union/tk-component-alerts';
import { SnackbarInterface, LONG_DISMISS_TIMEOUT } from '../../helpers/snackbar';
import { useHistory, useLocation } from 'react-router-dom';

const DashboardSnackbar = () => {
  const snackbar = useRef<SnackbarInterface>();
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const [snackbarShown, setSnackBarShown] = useState(false);
  if (
    snackbar?.current &&
    !snackbarShown &&
    (queryParams.get('source') === 'onboarding' || document.referrer.indexOf('gateway') !== -1)
  ) {
    snackbar.current.showAndDismiss({
      data: "Your website's ready! Next: add photos",
      dismissTimeout: LONG_DISMISS_TIMEOUT,
    });
    setSnackBarShown(true);
    if (queryParams.get('source') === 'onboarding') {
      queryParams.delete('source');
      history.replace({
        search: queryParams.toString(),
      });
    }
  }
  return <Snackbar ref={snackbar} />;
};

export default DashboardSnackbar;
